import { parseISO, format } from 'date-fns';

export function sortStringsAlphabetically(arr: string[]): string[] {
  return [...arr].sort((a, b) => a.localeCompare(b));
}

export const prepareSql = (str: string): string => {
  return str.replace(/'/g, "''");
};

export const generateSeries = (start: number, end: number, step: number): number[] => {
  const series: number[] = [];
  for (let value = start; value <= end; value += step) {
    series.push(value);
  }
  return series;
};

export const formatNumberWithCommas = (num: number, decimalPlaces?: number): string => {
  const formattedNumber = decimalPlaces !== undefined ? num.toFixed(decimalPlaces) : num.toString();
  return parseFloat(formattedNumber).toLocaleString('en-US', {
    minimumFractionDigits: decimalPlaces || 0,
    maximumFractionDigits: decimalPlaces || (formattedNumber.includes('.') ? formattedNumber.split('.')[1].length : 0),
  });
};

export const formatCreateDate = (date: string): string => {
  const dateObj = parseISO(date);
  const formattedDate = format(dateObj, 'MMMM dd');
  return formattedDate;
};
